import { render, staticRenderFns } from "./FaceRecognize.vue?vue&type=template&id=153b5b05&scoped=true&"
import script from "./FaceRecognize.vue?vue&type=script&lang=js&"
export * from "./FaceRecognize.vue?vue&type=script&lang=js&"
import style0 from "./FaceRecognize.vue?vue&type=style&index=0&id=153b5b05&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153b5b05",
  null
  
)

export default component.exports